import React from "react";
import { useNavigate } from "react-router-dom";
import { Button, Container, Row, Col, ProgressBar } from "react-bootstrap";
import Breadcrumbs from "../../components/breadcrumbs";
import { navigationStep } from "../../redux/slices/navigation";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import Arrow from "../../components/navigation/progress/svg/Arrow";
import Templates from "./Templates";



export const TemplatesScreen = () => {
  const dispatch = useDispatch();
  let navigate = useNavigate();
  const { lang, pageCounter } = useSelector(
    (state) => ({
      lang: state.changeLang.language.nav,
      pageCounter: state.navigation.pageCounter,
      langHowWorks: state.changeLang.language.cartType.howItWorks
    }),
    shallowEqual
  );
  const breadcrumbs = [
    {
      id: 0,
      name: "ME-QR",
      pathname: "/",
      isActive: false
    },
    {
      id: 1,
      name: lang.desktop[13],
      pathname: "/",
      isActive: false
    },
    {
      id: 3,
      name: lang.desktop[14],
      pathname: "/qr",
      isActive: true
    }
  ];

  const locale = useSelector((state) => state.changeLang.change);
  const handleBack = () => {
    handlerBtnNav(pageCounter);
  };

  function handlerBtnNav(id) {
    if (id === "") {
      const localePrefix = locale !== "en" ? `/${locale}` : "";
      window.location.href = `${localePrefix}/`;
    } else {
      dispatch(navigationStep(1));
      navigate("/");
    }
  }

  return (
    <>
      <Container>
          <div className="pt-3 mb-3">
            <Breadcrumbs breadcrumbs={breadcrumbs} />
          </div>

        <Row className="align-items-center justify-content-lg-between">
          <Col xs={3} lg={2}>

              <Button
                variant="outline-primary"
                className="text-capitalize w-75 fs-7 text-nowrap btn-back"
                onClick={handleBack}
              >
                <Arrow />{" "}
                <span className="d-none d-md-inline">{lang.desktop[0]}</span>
              </Button>

          </Col>
          <Col
            xs={6}
            md={4}
            className="py-2 text-center"
          >
            <p className="fw-bold mb-2 fs-md-5 fs-7">
              {lang.desktop[9]}
            </p>

            <ProgressBar animated className="progress-height">
              <ProgressBar variant="primary" now={25} />
              <ProgressBar
                variant="light-primary"
                now={75}
              />
            </ProgressBar>

          </Col>
          <Col
            xs={6}
            md={2}>
          </Col>
        </Row>
        <Templates />
      </Container>

    </>
  );
};